<template>
  <div>
    <b-container fluid>
      <!-- DATOS FAMILIARES -->
      <b-row id="progress-row">
        <b-progress v-if="loadingProgress.status" :value="loadingProgress.value" :variant="loadingProgress.color"
          :max=100 show-progress animated class="w-100"></b-progress>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="start">
            <b-col cols="auto">
              <b-row>
                <b-col>
                  <div v-if="editFamiliaItem.id === undefined">
                    <h1 class="mt-1">
                      <b-avatar icon="people-fill" variant="primary"></b-avatar>
                      Familia {{ family.display_name || '' }}
                    </h1>
                  </div>
                  <div v-if="editFamiliaItem.id !== undefined">
                    Familia :
                    <b-input v-model="editFamiliaItem.display_name"></b-input>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button variant="outline-primary" size="sm"
                    v-if="editFamiliaItem.id !== undefined && !formEnrollments" @click="guardarModificarFamilia()">
                    <b-icon icon="check-circle"></b-icon>
                  </b-button>
                  <b-button variant="outline-primary" size="sm"
                    v-if="editFamiliaItem.id !== undefined && !formEnrollments" class="ml-2"
                    @click="cancelarModificarFamilia()">
                    <b-icon icon="x-circle"></b-icon>
                  </b-button>
                  <b-button class="ml-2" size="sm" variant="outline-primary"
                    v-if="editFamiliaItem.id == undefined && !formEnrollments" @click="openPopNuevoAlumno()">
                    <b-icon icon="plus"></b-icon> Alumno
                  </b-button>

                  <b-button size="sm" variant="outline-primary"
                    v-if="editFamiliaItem.id == undefined && !formEnrollments" class="ml-2" @click="startEnrollment()">
                    <b-icon icon="plus"></b-icon> Inscripción
                  </b-button>
                  <b-button size="sm" class="ml-2" variant="outline-primary"
                    v-if="editFamiliaItem.id == undefined && !formEnrollments" @click="openPopregistrarPago()">
                    <b-icon icon="plus"></b-icon> Pago
                  </b-button>

                  <b-button size="sm" v-if="formEnrollments" variant="outline-secondary" style="margin-right: 5px"
                    @click="cancelEnrollment()">Cancelar</b-button>
                  <b-button size="sm" v-if="formEnrollments" style="margin-right: 5px" @click="saveDraft()"
                    variant="outline-primary">Guardar</b-button>
                  <b-button size="sm" v-if="formEnrollments" @click="confirmEnrollment()" variant="outline-primary">
                    Confirmar</b-button>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-card>
                <b-row>
                  <b-col>
                    <div v-if="editFamiliaItem.id === undefined">
                      <label class="labelFamilies">Contacto</label><br />
                      {{ family.x_contact_name || '' }}
                    </div>
                    <div v-if="editFamiliaItem.id !== undefined">
                      Contacto :
                      <b-input :v-model="editFamiliaItem.x_contact_name || ''"></b-input>
                    </div>
                  </b-col>
                  <b-col>
                    <label class="labelFamilies">Telefono</label><br />
                    <div v-if="editFamiliaItem.id === undefined">
                      <b-link :href="'https://api.whatsapp.com/send?phone=' + family.phone
          " target="_new">
                        {{ family.phone || '' }}
                      </b-link>
                    </div>
                    <div v-if="editFamiliaItem.id !== undefined">
                      <b-input v-model="editFamiliaItem.phone"></b-input>
                    </div>
                  </b-col>
                  <b-col>
                    <label class="labelFamilies" for="">DNI</label><br />
                    <div v-if="editFamiliaItem.id === undefined">
                      {{ family.vat || '' }}
                    </div>
                    <div v-if="editFamiliaItem.id !== undefined">
                      <b-input v-model="editFamiliaItem.vat"></b-input>
                    </div>
                  </b-col>
                  <b-col cols="auto">
                    <b-button variant="outline-primary" size="sm"
                      v-if="editFamiliaItem.id == undefined && !formEnrollments" @click="modificarFamilia(family)">
                      <b-icon icon="pencil-square"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label class="labelFamilies" for="">Correo</label><br />
                    <div v-if="editFamiliaItem.id === undefined">
                      {{ family.email || '' }}
                    </div>
                    <div v-if="editFamiliaItem.id !== undefined">
                      <b-input v-model="editFamiliaItem.email"></b-input>
                    </div>
                  </b-col>

                  <b-col>
                    <label class="labelFamilies" for="">Dirección</label><br />
                    <div v-if="editFamiliaItem.id === undefined">
                      {{ family.street || '' }}
                    </div>
                    <div v-if="editFamiliaItem.id !== undefined">
                      <b-input v-model="editFamiliaItem.street"></b-input>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col style="text-align: left"> </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <!-- FORM ENROLLMENT -->
    <div v-if="formEnrollments">
      <b-row>
        <b-col>
          <div v-if="formEnrollments">
            <b-row v-if="isLoadingSaleOrder"> cargando </b-row>
            <div v-if="!isLoadingSaleOrder">
              <b-row>
                <b-col>
                  <h1>Inscripcion - {{ saleOrder.name }}</h1>
                </b-col>
              </b-row>
              <b-row v-for="(v, k) in saleOrderItems" :key="k">
                <b-col>
                  <b-card>
                    <b-row>
                      <b-col>
                        {{ v.student.name }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="auto">
                        Curso <br />
                        <b-form-select label="Curso" @change="getSchedule(k)" v-model="v.sol.product_template_id"
                          :options="coursesOptions" size="sm" class="mt-3"></b-form-select><br />
                        <b-button @click="eliminarOrderLine(v)">cancelar</b-button>
                      </b-col>
                      <b-col>
                        Horarios <br />
                        <div v-if="v.schedule">
                          <b-form-group>
                            <b-form-radio-group v-model="v.sol.x_class_id">
                              <b-card class="text-left" v-for="(v, k) in v.schedule" :key="k">
                                <b-form-radio :value="v.id">({{ v.x_enrollments_ids.length }})
                                  {{ v.x_name }} - {{ v.x_teacher_id[1] }} -
                                  {{ v.x_room_id[1] }} <br />
                                  <h5 v-if="v.x_comment !== ''">
                                    <b-badge>{{ v.x_comment }}</b-badge>
                                  </h5>
                                </b-form-radio>
                              </b-card>
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                      </b-col>
                      <b-col v-if="v.schedule" cols="auto">
                        <label for="input-enrollment">Inscripcion:</label>
                        <b-form-input id="input-enrollment" v-model="v.sol.x_enrollment_fee" placeholder="Inscripcion"
                          trim></b-form-input>
                        <label for="input-enrollment">Marzo :</label>
                        <b-form-input id="input-enrollment" v-model="v.sol.x_march_fee" placeholder="Inscripcion" trim>
                        </b-form-input>
                        <label for="input-enrollment">Cuota :</label>
                        <b-form-input id="input-enrollment" v-model="v.sol.x_monthly_fee" placeholder="Inscripcion"
                          trim></b-form-input>
                        <label for="input-enrollment">Diciembre :</label>
                        <b-form-input id="input-enrollment" v-model="v.sol.x_december_fee" placeholder="Inscripcion"
                          trim></b-form-input>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- PAGINA -->
    <b-tabs content-class="mt-2" v-if="!formEnrollments">
      <b-tab title="Alumnos" active>
        <!-- Loading -->
        <b-row v-if="loadingStudents">
          <b-col>
            <LoadingSpinner></LoadingSpinner>
          </b-col>
        </b-row>
        <b-row v-if="!loadingStudents">
          <b-col v-for="(v, k) in students" :key="k" sm="12">
            <b-card style="margin-bottom: 15px">
              <b-card-text>
                <b-row>
                  <b-col cols="auto" class="pr-0 pt-1">
                    <b-avatar icon="person"></b-avatar>
                  </b-col>
                  <b-col>
                    <div v-if="editFamiliaItem.id === undefined">
                      <h2 class="mt-2">{{ v.name }}</h2>
                    </div>
                    <div v-if="editFamiliaItem.id !== undefined">
                      <label for="">Nombre: </label><br />
                      <b-input v-model="v.name"></b-input>
                    </div>
                  </b-col>
                  <b-col v-if="editFamiliaItem.id !== undefined">
                    <label for=""></label><br />
                    <b-form-checkbox :id="'skipfn_' + k" :key="v.id" v-model="v.x_skip_family_name"
                      name="skip_family_name" :value="true" :unchecked-value="false">
                      no usar apellido familiar
                    </b-form-checkbox>
                  </b-col>
                  <b-col>
                    <label for="">Fecha de Nacimiento: </label><br />
                    <div v-if="editFamiliaItem.id === undefined">
                      {{ v.date || '' }}
                    </div>
                    <div v-if="editFamiliaItem.id !== undefined">
                      <b-input v-model="v.date" type="date"></b-input>
                    </div>
                  </b-col>
                  <b-col>
                    <label for="">DNI: </label><br />
                    <div v-if="editFamiliaItem.id === undefined">
                      {{ v.x_dni || '' }}
                    </div>
                    <div v-if="editFamiliaItem.id !== undefined">
                      <b-input :v-model="v.x_dni || ''"></b-input>
                    </div>
                  </b-col>
                </b-row>
              </b-card-text>
              <b-tabs v-if="!loadingEnrollments & !loadingComments">
                <b-tab title="Inscripciones" active>
                  <b-row>
                    <b-col cols="12">
                      <b-table style="min-height: 150px" hover striped :items="v.enrollments" :fields="enrollmentFields"
                        responsive>
                        <template #cell(x_year_id)="data">
                          {{ data.item.x_year_id[1] !== 'False' ? data.item.x_year_id[1] : data.item.x_year }}
                        </template>
                        <template #cell(x_class_id)="data">
                          <b-link @click="gotoClase(data.item.x_class_id[0])">{{
          data.item.x_class_id[1]
        }}</b-link>
                        </template>
                        <template #cell(x_teacher_id)="data">
                          {{ data.item.clase.x_teacher_id[1] }}
                        </template>
                        <template #cell(gpa)="data">
                          <div v-if="data.item.resumenCursada">
                            {{ data.item.resumenCursada.Prom }}
                          </div>
                        </template>
                        <template #cell(x_status)="data">
                          {{
          $store.state.enrollment.x_status[data.item.x_status]
        }}
                        </template>
                        <template #cell(actions)="data">
                          <b-dropdown right text="">
                            <div v-if="data.item.x_status == 'active' || 'exam'">
                              <b-dropdown-item @click="verBoletin(data.item)">Imprimir Boletin</b-dropdown-item>
                              <b-dropdown-item @click="ImprimirCertificado(data.item)">Imprimir Certificado
                              </b-dropdown-item>
                              <b-dropdown-divider></b-dropdown-divider>
                            </div>
                            <div v-if="data.item.x_status == 'draft'">
                              <b-dropdown-item @click="confirmarInscripcion(data.item)">Confirmar inscripción
                              </b-dropdown-item>
                              <b-dropdown-divider></b-dropdown-divider>
                            </div>
                            <b-dropdown-item @click="openPopEliminarInscripcion(data.item)">Cancelar Inscripcion
                            </b-dropdown-item>

                            <b-dropdown-item @click="openPopModificarClase(data.item)">Modificar Clase</b-dropdown-item>
                          </b-dropdown>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="Comentarios">
                  <b-button variant="outline-primary" @click="openCommentModal(v)" class="mt-3 mb-3">
                    + comentario</b-button>
                  <b-table hover :items="v.comments" :fields="commentFields">
                    <template #cell(create_date)="data">
                      {{ data.item.create_uid[1] }} <br />
                      <div style="font-size:0.8em; color:gray">
                        {{ data.item.create_date }}
                      </div>
                    </template>
                  </b-table>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Inscripciones">
        <b-row>
          <b-col>
            <b-table hover striped :items="saleOrders" :fields="saleOrderFields">
              <template #cell(name)="data">
                <b-link @click="verVenta(data.item)">{{
          data.item.name
        }}</b-link>
              </template>
              <template #cell(date_order)="data">
                {{ getMoment(data.item.date_order) }}
              </template>
              <template #cell(descripcion)="data">
                <ul>
                  <li v-for="(v, k) in data.item.order_line" :key="k">
                    {{ v.name }} - $ {{ v.price_total }}
                  </li>
                </ul>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Cuotas Pendientes">
        <b-row style="margin-bottom: 15px">
          <b-col>
            <!-- <b-button
              style="margin-right: 5px"
              @click="openPopvalidarFacturas()"
              >validar facturas</b-button
            > -->
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table hover striped :items="accountMovesDraft" :fields="accountMoveFieldsDraft">
              <template #cell(date)="data">
                {{ data.item.invoice_date_due }}
              </template>
              <template #cell(display_name)="data">
                {{ data.item.invoice_line_ids[0].name }}
                <span style="font-size: 0.8em; font-weight: bold">{{
          data.item.narration
        }}</span>
              </template>
              <template #cell(invoice_origin)="data">
                <div v-if="data.item.invoice_origin">
                  <b-link @click="verVentaFromAccount(data.item.invoice_origin)">{{ data.item.invoice_origin }}</b-link>
                </div>
              </template>
              <template #cell(debe)="data">
                <div v-if="data.item.type == 'out_invoice'">
                  $ {{ data.item.amount_total }}
                </div>
              </template>
              <template #cell(haber)="data">
                <div v-if="data.item.type == 'entry'">
                  $ {{ data.item.amount_total }}
                </div>
              </template>
              <template #cell(invoice_payment_state)="data">
                <div v-if="data.item.invoice_payment_state">
                  {{ data.item.invoice_payment_state }}
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Cuenta Corriente">
        <b-row>
          <b-col>
            <b-table hover striped :items="accountMovesPosted" :fields="accountMoveFields">
              <template #cell(date)="data">
                <div v-if="data.item.state !== 'draft'">
                  {{ data.item.date }}
                </div>
              </template>
              <template #cell(display_name)="data">
                <b-link :href="API_URL +
          '/report/html/account.report_invoice_with_payments/' +
          data.item.id
          ">{{ data.item.display_name }}</b-link>
                <br />
                {{ data.item.invoice_line_ids[0].name }} <br />
                {{ data.item.narration }}
              </template>
              <template #cell(invoice_origin)="data">
                <div v-if="data.item.invoice_origin">
                  <b-link @click="verVentaFromAccount(data.item.invoice_origin)">{{ data.item.invoice_origin }}</b-link>
                </div>
              </template>
              <template #cell(debe)="data">
                <div v-if="data.item.type == 'out_invoice'">
                  $ {{ data.item.amount_total }}
                </div>
              </template>
              <template #cell(haber)="data">
                <div v-if="data.item.type == 'entry'">
                  $ {{ data.item.amount_total }}
                </div>
              </template>
              <template #cell(invoice_payment_state)="data">
                <div v-if="data.item.invoice_payment_state">
                  {{ data.item.invoice_payment_state }}
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
    <b-modal id="modal-eliminar-inscripcion" title="Eliminar Inscripción">
      <h5>
        Esta seguro que desea eliminar la inscripcion? este proceso no podra
        deshacerse.
      </h5>

      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button @click="eliminarInscripcion()"> Aceptar </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-ver-venta" size="xl" :title="modalSaleOrderTitle">
      <ver-venta :order_id="modalSaleOrderId" :family="family"></ver-venta>
    </b-modal>
    <b-modal id="modal-borrar-inscripcion" size="xl" title="Eliminar Inscripción">
      <enrollment-delete :so="enrollmentDeleteSO" :sol="enrollmentDeleteSOL" :item="enrollmentDeleteItem"
        :family="family"></enrollment-delete>
    </b-modal>
    <b-modal id="modal-validar-facturas" size="xl" title="Validar Facturas">
      <loading :active="loadingValidar" :is-full-page="false"></loading>
      <div v-if="loadingValidar" style="height: 500px"></div>
      <div v-if="!loadingValidar">
        <div v-for="(v, k) in facturasValidar" :key="k">
          <b-row v-for="(v2, k2) in v.invoice_line_ids" :key="k2">
            <b-col>
              <b-form-checkbox v-model="toValidate[v.id]" :value="true" :unchecked-value="false">
              </b-form-checkbox>
            </b-col>
            <b-col>{{ v.invoice_date_due }}</b-col>
            <b-col>{{ v.journal_id[1] }}</b-col>
            <b-col>{{ v2.name }}</b-col>
            <b-col>$ {{ v2.balance * -1 }}</b-col>
          </b-row>
        </div>
      </div>
      <template #modal-footer>
        <div>
          <b-button variant="primary" size="sm" class="float-right" @click="validarPopValidar()">
            Validar
          </b-button>
          <b-button variant="primary" size="sm" class="float-right" @click="cancelarPopValidar()">
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal id="modal-registrar-pagos" size="xl" title="Registrar Pagos">
      <b-row>
        <b-col>
          <b-form-select v-model="selectedJournal" :options="journalOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-form-datepicker v-model="paymentDate" class="mb-2"></b-form-datepicker>
        </b-col>
      </b-row>
      <loading :active="loadingPagos" :is-full-page="false"></loading>
      <div v-if="loadingPagos" style="height: 500px"></div>
      <div v-if="!loadingPagos">
        <b-table striped hover :items="facturasPagar" :fields="[
          { key: 'sel', label: '' },
          { key: 'invoice_date_due', label: 'Fecha Venc' },
          { key: 'name', label: 'Concepto' },
          { key: 'narration', label: 'Comentario' },
          'total',
        ]">
          <template #cell(sel)="data">
            <b-form-checkbox v-model="toPay[data.item.id]" style="float: left" :value="true" :unchecked-value="false"
              @change="updateTotalPaymentAmount(data.item.id)">
            </b-form-checkbox>
          </template>
          <template #cell(name)="data">
            {{ data.item.invoice_line_ids[0].name }}
          </template>
          <template #cell(narration)="data">
            <div v-if="toPay[data.item.id] == 'false'">
              {{ data.item.narration }}
            </div>
            <div v-if="toPay[data.item.id] === 'true'">
              <b-input v-model="toPayNarration[data.item.id]"></b-input>
            </div>
          </template>
          <template #cell(total)="data">
            $ {{ data.item.invoice_line_ids[0].price_unit }}
          </template>
        </b-table>

        <b-row>
          <b-col>
            <div style="float: right; font-size: 1.2em; font-weight: bold">
              Total a pagar: $ {{ totalToPay }}
            </div>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div>
          <b-button variant="primary" size="sm" class="float-right ml-2" @click="validarPopPagar()">
            Validar
          </b-button>
          <b-button variant="outline-secondary" size="sm" class="float-right" @click="cancelarPopPagar()">
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal id="modal-nuevo-alumno" size="xl" title="Nuevo Alumno">
      <label for="input-dni">Nuevo Alumno</label>
      <b-form-input id="input-input-nombre" v-model="NewStudent.name"></b-form-input>
      <label for="input-dni">DNI</label>
      <b-form-input id="input-dni" v-model="NewStudent.x_dni"></b-form-input>
      <label for="input-date">Fecha de Cumpleaños</label>
      <b-input-group class="mb-3">
        <b-form-input id="input-date" v-model="NewStudent.date" type="text" placeholder="YYYY-MM-DD" autocomplete="off">
        </b-form-input>
        <b-input-group-append>
          <b-form-datepicker v-model="NewStudent.date" button-only right locale="as-AR" aria-controls="input-date"
            @context="onContext"></b-form-datepicker>
        </b-input-group-append>
      </b-input-group>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button @click="createStudent()"> Crear </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-modificar-clase" size="xl" title="Modificar Clase">
      <b-row v-if="!isLoading && modalModificarClaseItem.x_student_id" style="font-size: 1.2em">
        <b-col>{{ modalModificarClaseItem.x_student_id[1] }}</b-col>
        <b-col>
          ({{ modalModificarClaseCurrent.x_enrollments_ids.length }}) -
          {{ modalModificarClaseItem.x_class_id[1] }}
        </b-col>
        <b-col>{{ modalModificarClaseItem.x_sale_order_id[1] }}</b-col>
      </b-row>
      <hr />
      <b-row v-if="!isLoading">
        <b-col>
          <b-form-group>
            <b-form-radio-group v-model="modalModificarClaseSelected">
              <div v-for="(v, k) in modalModificarClaseClases" :key="k">
                <b-form-radio :value="v.id">({{ v.x_enrollments_ids.length }}){{ v.x_name }} -
                  {{ v.x_teacher_id[1] }} - {{ v.x_room_id[1] }} -
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button @click="executeClassChange()"> Modificar </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-comentario-alumno" size="lg" title="Nuevo comentario">
      <div v-if="isLoadingPop">Cargando</div>
      <div v-if="!isLoadingPop">
        <b-form-textarea v-model="modalNewCommentStudents" placeholder="Comentario..." rows="3" max-rows="6">
        </b-form-textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel" variant="link"> Cancelar </b-button>
        <b-button @click="guardarComentario()" variant="primary">
          Guardar
        </b-button>
      </template>
    </b-modal>
    <div v-if="!isLoadingPop">
      <boletin :modalPeriodScorebooks="modalPeriodScorebooks" />
    </div>
    <div v-if="!isLoadingCert">
      <certificado :modalPeriodScorebooks="modalPeriodScorebooks" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VerVenta from './VerVenta.vue'
import EnrollmentDelete from './FamiliesEnrollmentDelete.vue'

import invoiceManagement from '../mixins/invoiceManagement'

import { FamiliesService } from '@/services/families.service'

import { EnrollmentsService } from '@/services/enrollments.service'
import { ClassesService } from '@/services/classes.service'
import { SaleOrdersService } from '@/services/sale.orders.service'
import { SaleOrderLinesService } from '@/services/sale.order.lines.service'
import { ProductsService } from '@/services/product.product.service'
import { AccountMoveService } from '@/services/account.move.service'
import { AccountPaymentService } from '@/services/account.payment.service'
import { AccountMoveLineService } from '@/services/account.move.line.service'
import { AccountJournalService } from '@/services/account.journal.service'
import { ScorebookService } from '@/services/scorebook.service'
import { PeriodsService } from '@/services/periods.service'
import { ScoreTypeService } from '@/services/score.type.service'
import { CoursesService } from '@/services/courses.service'
import { TeacherService } from '@/services/teacher.service'
// import { PeriodTeacherNotesService } from '@/services/period.teacher.notes.service'
// import { ScheduleService } from '@/services/schedule.service'
// import { RecordCommentService } from '@/services/record.comment.service'
import { ClassCommentService } from '@/services/class_comment.service'
import LoadingSpinner from './../components/LoadingSpinner.vue'
import Boletin from './../components/Boletin.vue'
import Certificado from './../components/Certificado.vue'
import Loading from 'vue-loading-overlay'
// import { ScorebookService } from '@/services/scorebook.service'

export default {
  name: 'Families',
  mixins: [invoiceManagement],
  data () {
    return {
      API_URL: AccountMoveService.API_URL(),
      isLoading: true,
      isLoadingPop: true,
      isLoadingCert: true,
      formEnrollments: false,
      loadingValidar: true,
      loadingPagos: true,
      loadingStudents: true,
      loadingComments: true,
      loadingEnrollments: true,
      fields: [],
      commentFields: [
        { key: 'create_date', label: 'Creado Por' },
        { key: 'x_comment', label: 'Comentario' }
      ],
      enrollmentFields: [
        {
          key: 'x_year_id',
          label: 'Año',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'x_class_id',
          label: 'Clase',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'x_teacher_id',
          label: 'Docente',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'gpa',
          label: 'Promedio',
          sortable: false
        },
        {
          key: 'x_status',
          label: 'Estado',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false,
          sortDirection: 'desc'
        }
      ],
      family: [],
      students: [],
      isLoadingSaleOrder: true,
      saleOrder: {},
      monthlyFees: {},
      saleOrderLines: [],
      saleOrderItems: [],
      loadingProgress: {
        status: false,
        value: 20,
        color: 'primary'
      },
      accountMoves: [],
      accountMoveFields: [
        { key: 'date', label: 'Fecha Pago' },
        { key: 'invoice_origin', label: 'Inscripción' },
        { key: 'display_name', label: 'Concepto' },
        { key: 'debe', label: 'Pagó' }
      ],
      accountMoveFieldsDraft: [
        { key: 'date', label: 'Fecha Vencimiento' },
        { key: 'invoice_origin', label: 'Inscripción' },
        { key: 'display_name', label: 'Concepto' },
        { key: 'debe', label: 'Debe' }
      ],
      saleOrders: [],
      saleOrderFields: [
        { key: 'name', label: 'Venta' },
        { key: 'date_order', label: 'Fecha' },
        { key: 'descripcion', label: 'Descripción' }
      ],

      modalSaleOrderId: false,
      modalSaleOrderTitle: '',

      facturasValidar: [],
      facturasPagar: [],
      facturasPagarObj: {},
      toPay: {},
      toPayNarration: {},
      totalToPay: 0,
      paymentJournals: [],
      selectedJournal: {},
      paymentDate: null,

      NewStudent: {},
      NewContact: {},

      enrollmentDeleteSO: {},
      enrollmentDeleteSOL: {},
      enrollmentDeleteItem: {},

      modalModificarClaseItem: {},
      modalModificarClaseSelected: null,
      modalModificarClaseClases: [],
      modalModificarClaseCurrent: {},
      accountMoveLines: [],
      grupoContactos: [],
      modalModificarPartnerItem: {},

      modalPeriodScorebooks: {},

      modalCommentStudent: {},
      modalNewCommentStudents: '',

      editFamiliaItem: {},
      editAlumnoItem: {}
    }
  },
  components: {
    VerVenta,
    EnrollmentDelete,
    LoadingSpinner,
    Boletin,
    Certificado,
    Loading
  },
  computed: {
    accountMovesDraft: function () {
      const ret = []
      for (let i = 0; i < this.accountMoves.length; i++) {
        if (this.accountMoves[i].state === 'draft') {
          ret.push(this.accountMoves[i])
        }
      }

      return ret.reverse()
    },
    accountMovesPosted: function () {
      const ret = []
      for (let i = 0; i < this.accountMoves.length; i++) {
        if (this.accountMoves[i].state === 'posted') {
          ret.push(this.accountMoves[i])
        }
      }
      return ret
    },
    total: function () {
      // console.log(this.toPay)
      return 'ok'
    },
    journalOptions: function () {
      const ret = []
      for (let i = 0; i < this.paymentJournals.length; i++) {
        ret.push({
          text: this.paymentJournals[i].name,
          value: this.paymentJournals[i].id
        })
      }
      return ret
    },
    toValidate: function () {
      const ret = {}
      for (let i = 0; i < this.facturasValidar.length; i++) {
        ret[this.facturasValidar[i].id] = false
      }
      return ret
    },
    ventasCount: function () {
      return this.family.sale_order_ids.length
    },
    coursesOptions: function () {
      const list = this.$store.state.course.list
      const ret = []
      for (let i = 0; i < list.length; i++) {
        ret.push({
          value: list[i].id,
          text: list[i].display_name,
          item: list[i]
        })
      }
      return ret
    },
    courses: function () {
      const list = this.$store.state.course.list
      const ret = {}
      for (let i = 0; i < list.length; i++) {
        ret[list[i].id] = list[i]
      }
      return ret
    }
  },

  async created () {
    await this.updateFamily()
    // console.log(this.family)
    this.updateAccountMoves()
    this.updateSaleOrders()
  },
  methods: {
    getMoment (date) {
      const str = moment(date).locale('es').format('LLLL')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    async guardarModificarFamilia () {
      this.isLoading = true
      const data = {
        display_name: this.editFamiliaItem.display_name,
        phone: this.editFamiliaItem.phone,
        email: this.editFamiliaItem.email,
        street: this.editFamiliaItem.street,
        vat: this.editFamiliaItem.vat,
        x_contact_name: this.editFamiliaItem.x_contact_name
      }
      await FamiliesService.update(this.editFamiliaItem.id, data)
      for (let i = 0; i < this.students.length; i++) {
        const data = {
          name: this.students[i].name,
          date: this.students[i].date,
          email: this.students[i].email,
          phone: this.students[i].phone,
          vat: this.students[i].vat,
          x_skip_family_name: this.students[i].x_skip_family_name
        }
        await FamiliesService.update(this.students[i].id, data)
      }
      this.editFamiliaItem = {}
      this.isLoading = false
    },
    cancelarModificarFamilia () {
      this.isLoading = true
      this.editFamiliaItem = {}
      this.isLoading = false
    },
    modificarFamilia (family) {
      this.isLoading = true
      this.editFamiliaItem = family
      this.isLoading = false
    },
    async guardarComentario () {
      this.isLoadingPop = true
      // console.log(this.modalNewCommentStudents, this.modalCommentStudent.id)
      if (this.modalNewCommentStudents !== '') {
        const newComment = {
          x_comment: this.modalNewCommentStudents,
          x_res_partner_id: this.modalCommentStudent.id,
          x_create_user: this.$store.state.user.currentUser.id
        }
        await ClassCommentService.create(newComment)
        await this.updateFamily()
        this.modalNewCommentStudents = ''
      }
      this.$bvModal.hide('modal-comentario-alumno')
      this.isLoadingPop = false
      // console.log(await ClassCommentService.list({}))
    },
    openCommentModal (student) {
      this.modalCommentStudent = student
      this.$bvModal.show('modal-comentario-alumno')
      this.isLoadingPop = false
    },
    saveCommentModal () {
      console.log(this.modalNewCommentStudents)
    },
    countCertainDays (days, d0, d1) {
      var ndays = 1 + Math.round((d1 - d0) / (24 * 3600 * 1000))
      var sum = function (a, b) {
        return a + Math.floor((ndays + ((d0.getDay() + 6 - b) % 7)) / 7)
      }
      return days.reduce(sum, 0)
    },
    async ImprimirCertificado (item) {
      this.isLoadingCert = true
      this.loadingProgress = {
        status: true,
        value: 0,
        color: 'primary'
      }
      const periods = await PeriodsService.list({
        x_year_id: item.x_year_id[0],
        x_type: 'exam'
      })

      periods.sort(function (a, b) {
        return new Date(a.x_start_date) - new Date(b.x_start_date)
      })

      for (let i = 0; i < periods.length; i++) {
        moment.locale('es')
        periods[i].x_start_date =
          moment(periods[i].x_start_date).format('DD MMMM').slice(0, 3) +
          moment(periods[i].x_start_date)
            .format('DD MMMM')
            .charAt(3)
            .toUpperCase() +
          moment(periods[i].x_start_date).format('DD MMMM').slice(4)
        periods[i].x_end_date =
          moment(periods[i].x_end_date).format('DD MMMM').slice(0, 3) +
          moment(periods[i].x_end_date)
            .format('DD MMMM')
            .charAt(3)
            .toUpperCase() +
          moment(periods[i].x_end_date).format('DD MMMM').slice(4)
        periods[i].scoretype = await ScoreTypeService.list({
          x_period_id: periods[i].id,
          x_advanced_class: item.clase.x_advanced_class
        })

        for (let j = 0; j < periods[i].scoretype.length; j++) {
          periods[i].scoretype[j].key = periods[i].scoretype[j].display_name
            .replaceAll(' ', '_')
            .toLowerCase()
        }
        // console.log(periods)

        try {
          periods[i].scorebook = (
            await ScorebookService.searchRead(
              {
                x_enrollment_id: parseInt(item.id),
                x_periods_id: parseInt(periods[i].id)
              },
              [],
              { order: 'create_date desc', limit: 1 }
            )
          )[0]
          // console.log(periods[i])
        } catch (error) {
          console.log(error)
        }

        if (periods[i].scorebook !== undefined) {
          periods[i].scorebook.score = JSON.parse(
            periods[i].scorebook.x_score.replaceAll("'", '"')
          )
        }
        this.loadingProgress = {
          status: true,
          value: Math.round((i * 100) / periods.length),
          color: (i === periods.length - 1) ? 'success' : 'primary'
        }
      }

      const student = await FamiliesService.read(item.x_student_id[0])

      if (student[0].x_skip_family_name) {
        item.x_student_id[1] = student[0].name
      }
      this.modalPeriodScorebooks.item = item
      this.modalPeriodScorebooks.items = periods
      this.modalPeriodScorebooks.class = (
        await ClassesService.read(item.x_class_id[0])
      )[0]

      this.modalPeriodScorebooks.course = (
        await CoursesService.read(
          this.modalPeriodScorebooks.class.x_product_template_id[0]
        )
      )[0]

      this.modalPeriodScorebooks.teacher = (
        await TeacherService.read(
          this.modalPeriodScorebooks.class.x_teacher_id[0]
        )
      )[0]
      this.modalPeriodScorebooks.sup = (
        await TeacherService.read(
          this.modalPeriodScorebooks.course.x_2nd_signature_id[0]
        )
      )[0]
      // console.log(this.modalPeriodScorebooks)

      this.isLoadingCert = false
      this.loadingProgress = {
        status: false,
        value: 0,
        color: 'success'
      }
    },
    async verBoletin (item) {
      this.isLoadingPop = true
      this.loadingProgress = {
        status: true,
        value: 0,
        color: 'primary'
      }
      const periods = await PeriodsService.list({
        x_year_id: item.x_year_id[0],
        x_type: 'course'
      })

      periods.sort(function (a, b) {
        return new Date(a.x_start_date) - new Date(b.x_start_date)
      })

      for (let i = 0; i < periods.length; i++) {
        moment.locale('es')
        periods[i].x_start_date =
          moment(periods[i].x_start_date).format('DD MMMM').slice(0, 3) +
          moment(periods[i].x_start_date)
            .format('DD MMMM')
            .charAt(3)
            .toUpperCase() +
          moment(periods[i].x_start_date).format('DD MMMM').slice(4)
        periods[i].x_end_date =
          moment(periods[i].x_end_date).format('DD MMMM').slice(0, 3) +
          moment(periods[i].x_end_date)
            .format('DD MMMM')
            .charAt(3)
            .toUpperCase() +
          moment(periods[i].x_end_date).format('DD MMMM').slice(4)
        periods[i].scoretype = await ScoreTypeService.list({
          x_period_id: periods[i].id,
          x_advanced_class: item.clase.x_advanced_class
        })
        // console.log(periods)
        for (let j = 0; j < periods[i].scoretype.length; j++) {
          periods[i].scoretype[j].key = periods[i].scoretype[j].display_name
            .replaceAll(' ', '_')
            .toLowerCase()
        }
        try {
          periods[i].scorebook = (
            await ScorebookService.searchRead(
              {
                x_enrollment_id: parseInt(item.id),
                x_periods_id: parseInt(periods[i].id)
              },
              [],
              { order: 'create_date desc', limit: 1 }
            )
          )[0]
          // console.log(periods[i])
        } catch (error) {
          console.log(error)
        }

        if (periods[i].scorebook !== undefined) {
          periods[i].scorebook.score = JSON.parse(
            periods[i].scorebook.x_score.replaceAll("'", '"')
          )

          periods[i].assistance = periods[i].scorebook.x_attendance_percentage
          periods[i].homework = periods[i].scorebook.x_homework_percentage
        }
        this.loadingProgress = {
          status: true,
          value: Math.round((i * 100) / periods.length),
          color: (i === periods.length - 1) ? 'success' : 'primary'
        }
      }
      const student = await FamiliesService.read(item.x_student_id[0])

      if (student[0].x_skip_family_name) {
        item.x_student_id[1] = student[0].name
      }
      this.modalPeriodScorebooks.item = item
      this.modalPeriodScorebooks.items = periods
      this.modalPeriodScorebooks.class = (
        await ClassesService.read(item.x_class_id[0])
      )[0]

      this.modalPeriodScorebooks.course = (
        await CoursesService.read(
          this.modalPeriodScorebooks.class.x_product_template_id[0]
        )
      )[0]

      this.modalPeriodScorebooks.teacher = (
        await TeacherService.read(
          this.modalPeriodScorebooks.class.x_teacher_id[0]
        )
      )[0]
      this.modalPeriodScorebooks.sup = (
        await TeacherService.read(
          this.modalPeriodScorebooks.course.x_2nd_signature_id[0]
        )
      )[0]
      // console.log(this.modalPeriodScorebooks)
      this.isLoadingPop = false
      this.loadingProgress = {
        status: false,
        value: 0,
        color: 'success'
      }
    },
    async executePartnerChange () {
      this.isLoading = true
      const newD = this.modalModificarPartnerItem
      const item = {
        name: newD.name,
        phone: newD.phone,
        email: newD.email,
        street: newD.street,
        vat: newD.vat,
        date: newD.date
      }
      await FamiliesService.update(this.modalModificarPartnerItem.id, item)
      this.isLoading = false
      // console.log(item)
      this.$bvModal.hide('modal-modificar-partner')
    },
    async openPopModificarPartner (partner) {
      // console.log(partner)
      this.modalModificarPartnerItem = partner
      this.$bvModal.show('modal-modificar-partner')
    },
    async confirmarInscripcion (item) {
      // console.log(item)
      await EnrollmentsService.update(item.id, { x_status: 'active' })
      await this.updateFamily()
      // console.log(this.family)
      this.updateAccountMoves()
      this.updateSaleOrders()
    },
    gotoClase (id) {
      this.$router.push({ path: '/classes/' + id })
    },
    async executeClassChange () {
      this.isLoading = true
      // console.log(this.modalModificarClaseItem.x_status)
      // // console.log(await ScorebookService.list({ x_enrollment_id: this.modalModificarClaseItem.id }))
      // console.log(this.modalModificarClaseSelected)
      const item = {
        x_class_id: this.modalModificarClaseSelected
      }
      await EnrollmentsService.update(this.modalModificarClaseItem.id, item)
      this.updateFamily()
      this.$bvModal.hide('modal-modificar-clase')
      this.isLoading = false
    },
    async openPopModificarClase (item) {
      this.isLoading = true
      this.modalModificarClaseClases = []
      this.modalModificarClaseItem = item
      const sol = await SaleOrderLinesService.read(
        [item.x_sale_order_line_id[0]],
        []
      )
      // console.log(sol)
      const tmp = await ClassesService.list({
        x_year_id: this.$store.state.year.selected.id,
        x_product_template_id: sol[0].product_id[0]
      })

      for (let i = 0; i < tmp.length; i++) {
        if (tmp[i].id !== item.x_class_id[0]) {
          this.modalModificarClaseClases.push(tmp[i])
        } else {
          this.modalModificarClaseCurrent = tmp[i]
        }
      }
      // console.log(this.modalModificarClaseClases)
      this.$bvModal.show('modal-modificar-clase')
      this.isLoading = false
    },
    openPopEliminarInscripcion (item) {
      this.modalInscripcionEliminar = item
      this.$bvModal.show('modal-eliminar-inscripcion')
    },
    async eliminarInscripcion () {
      this.enrollmentDeleteSO = await SaleOrdersService.read(
        [this.modalInscripcionEliminar.x_sale_order_id[0]],
        []
      )
      this.enrollmentDeleteSOL = await SaleOrderLinesService.list({
        order_id: this.modalInscripcionEliminar.x_sale_order_id[0]
      })
      this.enrollmentDeleteItem = this.modalInscripcionEliminar
      await this.updateFamily()
      this.$bvModal.show('modal-borrar-inscripcion')
    },
    onContext (ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD
    },
    async createStudent () {
      // console.log(this.NewStudent)
      this.NewStudent.parent_id = this.family.id
      await FamiliesService.create(this.NewStudent)
      await this.updateFamily()
      this.NewStudent = {}
      this.$bvModal.hide('modal-nuevo-alumno')
    },
    openPopNuevoAlumno () {
      this.$bvModal.show('modal-nuevo-alumno')
    },
    updateTotalPaymentAmount (val) {
      const keys = Object.keys(this.toPay)
      this.totalToPay = 0
      for (let i = 0; i < keys.length; i++) {
        if (this.toPay[keys[i]] === 'true') {
          this.totalToPay += -1 * this.facturasPagarObj[keys[i]][0].balance
        }
      }
    },
    cancelarPopPagar () {
      this.$bvModal.hide('modal-registrar-pagos')
    },
    async openPopregistrarPago () {
      this.facturasPagar = []
      this.toPay = {}
      this.toPayNarration = {}
      this.loadingPagos = true
      this.totalToPay = 0
      this.$bvModal.show('modal-registrar-pagos')
      this.facturasPagar = (
        await AccountMoveService.list(
          {
            state: 'draft',
            // invoice_payment_state: 'not_paid',
            partner_id: this.family.id
          },
          [],
          { order: 'invoice_date_due asc' }
        )
      ).reverse()
      this.paymentJournals = await AccountJournalService.list(
        { type: ['cash', 'bank'] },
        ['name', 'id']
      )

      const promisesFacturas = await Promise.all(
        this.facturasPagar.map((elem) => {
          // console.log(elem)
          const esto = AccountMoveLineService.list({
            id: elem.invoice_line_ids[0]
          })
          // console.log('aja', esto)
          return esto
        })
      )

      for (let i = 0; i < promisesFacturas.length; i++) {
        this.facturasPagar[i].invoice_line_ids = promisesFacturas[i]
        this.toPay[this.facturasPagar[i].id] = false
        this.toPayNarration[this.facturasPagar[i].id] =
          this.facturasPagar[i].narration
        this.facturasPagarObj[this.facturasPagar[i].id] = promisesFacturas[i]
      }
      // console.log(this.facturasPagar)
      this.loadingPagos = false
    },

    async validarPopPagar () {
      this.loadingPagos = true
      const keys = Object.keys(this.toPay)
      const invoices = []
      for (let i = 0; i < keys.length; i++) {
        if (this.toPay[keys[i]]) {
          invoices.push(this.facturasPagarObj[keys[i]][0])
        }
      }

      for (let i = 0; i < invoices.length; i++) {
        await AccountMoveService.execute('action_post', [
          [invoices[i].move_id[0]]
        ])
        await AccountMoveService.update(invoices[i].move_id[0], {
          narration: this.toPayNarration[invoices[i].move_id[0]]
        })

        const newPayment = {
          amount: parseFloat(invoices[i].price_total),
          journal_id: parseInt(this.selectedJournal),
          currency_id: 19,
          payment_date: this.paymentDate,
          payment_method_id: 1,
          payment_type: 'inbound',
          partner_type: 'customer',
          partner_id: parseInt(this.family.id),
          invoice_ids: [invoices[i].move_id[0]]
        }
        // console.log(newPayment)
        const paymentId = await AccountPaymentService.create(newPayment)
        await AccountPaymentService.execute('post', [[paymentId]])
        this.loadingPagos = false
      }

      this.updateFamily()
      this.updateAccountMoves()
      this.$bvModal.hide('modal-registrar-pagos')
    },

    async validarPopValidar () {
      const keys = Object.keys(this.toValidate)
      for (let i = 0; i < keys.length; i++) {
        if (this.toValidate[keys[i]]) {
          await AccountMoveService.execute('action_post', [
            [parseInt(keys[i])]
          ])
        }
      }
      this.updateAccountMoves()
      this.updateFamily()
      this.$bvModal.hide('modal-validar-facturas')
    },
    cancelarPopValidar () {
      this.$bvModal.hide('modal-validar-facturas')
    },
    async openPopvalidarFacturas () {
      this.loadingValidar = true
      this.$bvModal.show('modal-validar-facturas')
      // console.log('entro')
      this.facturasValidar = await AccountMoveService.list({
        state: 'draft',
        partner_id: this.family.id
      })
      this.facturasValidar = this.facturasValidar.reverse()
      const promisesFacturas = await Promise.all(
        this.facturasValidar.map((elem) => {
          const esto = AccountMoveLineService.list({
            id: elem.invoice_line_ids[0]
          })
          // console.log('aja', esto)
          return esto
        })
      )
      for (let i = 0; i < promisesFacturas.length; i++) {
        this.facturasValidar[i].invoice_line_ids = promisesFacturas[i]
      }
      this.loadingValidar = false
    },
    verVenta (item) {
      this.modalSaleOrderId = item.id
      this.modalSaleOrderTitle =
        this.family.name + ' - ' + item.display_name + ' - ' + item.create_date
      this.$bvModal.show('modal-ver-venta')
    },
    async verVentaFromAccount (item) {
      const so = await SaleOrdersService.list({ name: item })

      this.modalSaleOrderId = so[0].id
      this.modalSaleOrderTitle =
        this.family.name +
        ' - ' +
        so[0].display_name +
        ' - ' +
        so[0].create_date
      this.$bvModal.show('modal-ver-venta')
    },

    async updateSaleOrders () {
      this.saleOrders = await SaleOrdersService.list(
        { partner_id: this.family.id },
        { limit: 20, order: 'id desc' }
      )
      for (let i = 0; i < this.saleOrders.length; i++) {
        this.saleOrders[i].order_line = await SaleOrderLinesService.list({
          order_id: this.saleOrders[i].id,
          is_downpayment: false
        })
      }
      this.$forceUpdate()
    },
    async updateAccountMoves (limit = 30) {
      this.accountMoves = await AccountMoveService.list(
        { partner_id: this.family.id, type: 'out_invoice' },
        { limit: limit, order: 'id desc' }
      )

      const promises = []
      for (let i = 0; i < this.accountMoves.length; i++) {
        // console.log(this.accountMoves[i])
        promises.push(
          AccountMoveLineService.read(this.accountMoves[i].invoice_line_ids)
        )
      }

      const accountMoveLines = await Promise.all(promises)
      for (let i = 0; i < accountMoveLines.length; i++) {
        this.accountMoves[i].invoice_line_ids = accountMoveLines[i]
      }
      // console.log(this.accountMoves)
    },

    async updateFamily () {
      this.loadingStudents = true
      this.loadingEnrollments = true
      this.loadingComments = true
      this.family = await FamiliesService.read(
        [parseInt(this.$route.params.id)],
        []
      )
      this.family = this.family[0]
      this.students = await FamiliesService.read(this.family.child_ids, [])
      this.loadingStudents = false
      for (let i = 0; i < this.students.length; i++) {
        this.students[i].comments = await ClassCommentService.read(
          this.students[i].x_class_comment_ids,
          []
        )
        this.students[i].comments = this.students[i].comments.reverse()
        this.loadingComments = false
        // console.log(this.students[i])
        this.students[i].enrollments = await EnrollmentsService.read(
          this.students[i].x_enrollment_ids,
          []
        )
        // console.log('student: ', this.students[i].enrollments)

        this.students[i].enrollments.sort((a, b) => {
          return (b.x_year).localeCompare(a.x_year)
        })

        for (let j = 0; j < this.students[i].enrollments.length; j++) {
          this.students[i].enrollments[j].clase = (
            await ClassesService.read([
              this.students[i].enrollments[j].x_class_id[0]
            ])
          )[0]
          // console.log(this.students[i].enrollments[j].x_GPA)

          if (this.students[i].enrollments[j].x_GPA !== false) {
            this.students[i].enrollments[j].x_GPA = this.students[i].enrollments[j].x_GPA.replaceAll("'", '"')
            // console.log(this.students[i].enrollments[j].x_GPA)
            this.students[i].enrollments[j].x_GPA = JSON.parse(this.students[i].enrollments[j].x_GPA)
            // console.log(this.students[i].enrollments[j].x_GPA)
            let promedioGlobal = 0
            for (const item in this.students[i].enrollments[j].x_GPA) {
              // console.log(item, this.students[i].enrollments[j].x_GPA[item])
              promedioGlobal += parseFloat(this.students[i].enrollments[j].x_GPA[item])
            }
            this.students[i].enrollments[j].resumenCursada = { Prom: (promedioGlobal / Object.keys(this.students[i].enrollments[j].x_GPA).length).toFixed(2) }
          }
        }
        this.loadingEnrollments = false
      }
    },
    async startEnrollment () {
      this.saleOrder = {}
      this.saleOrderItems = []
      this.saleOrderLines = []
      this.isLoadingSaleOrder = true
      this.saleOrder = await this.getDraftSo(this.family.id)

      this.saleOrderLines = await SaleOrderLinesService.read(
        this.saleOrder.order_line
      )
      // console.log('asd')
      for (let i = 0; i < this.students.length; i++) {
        let sol = {}
        for (let j = 0; j < this.saleOrderLines.length; j++) {
          if (this.saleOrderLines[j].x_student_id[0] === this.students[i].id) {
            sol = this.saleOrderLines[j]
            sol.product_template_id = sol.product_template_id[0]
            sol.x_class_id = sol.x_class_id[0]
          }
        }
        const schedule = await ClassesService.list({
          x_year_id: this.$store.state.year.selected.id,
          x_product_template_id: sol.product_template_id
        })
        this.saleOrderItems.push({
          student: this.students[i],
          sol: sol,
          schedule: schedule
        })
      }
      this.isLoadingSaleOrder = false
      this.formEnrollments = true
    },
    async cancelEnrollment () {
      this.formEnrollments = false
    },
    async getSchedule (index) {
      // this.isLoadingSaleOrder = true
      // console.log(this.saleOrderItems)
      const item = this.saleOrderItems[index]
      this.saleOrderItems[index].schedule = await ClassesService.list({
        x_year_id: this.$store.state.year.selected.id,
        x_product_template_id: item.sol.product_template_id
      })
      // console.log(this.saleOrderItems[index].schedule, 'SCHEDULE')

      const product = await ProductsService.list({
        product_tmpl_id: item.sol.product_template_id
      })

      this.saleOrderItems[index].course =
        this.courses[item.sol.product_template_id]
      this.saleOrderItems[index].sol.x_enrollment_fee =
        item.course.x_enrollment_fee
      this.saleOrderItems[index].sol.x_march_fee = item.course.x_march_fee
      // this.saleOrderItems[index].sol.x_monthly_fee = item.course.x_1st_fee

      this.saleOrderItems[index].sol.x_december_fee =
        item.course.x_december_fee
      this.saleOrderItems[index].sol.price_unit =
        item.sol.x_enrollment_fee +
        item.sol.x_march_fee +
        8 * item.sol.x_monthly_fee +
        item.sol.x_december_fee
      this.saleOrderItems[index].sol.product_uom_qty = 1
      this.saleOrderItems[index].sol.x_student_id = item.student.id
      this.saleOrderItems[index].sol.product_id = product[0].id
      this.saleOrderItems[index].sol.name =
        'Inscripción de ' + item.student.name + ' en ' + item.course.name
      this.isLoadingSaleOrder = false
      let price = '1st'
      // console.log(item.course)
      for (let i = 0; i < this.saleOrderItems.length; i++) {
        // console.log(price)
        if (this.saleOrderItems[i].course !== undefined) {
          if (price === '1st') {
            // console.log(item.course.x_1st_fee)
            this.saleOrderItems[index].sol.x_monthly_fee =
              item.course.x_1st_fee
            price = '2nd'
          } else if (price === '2nd') {
            // console.log(item.course.x_2nd_fee)
            this.saleOrderItems[index].sol.x_monthly_fee =
              item.course.x_2nd_fee
            price = '3rd'
          } else if (price === '3rd') {
            // console.log(item.course.x_3rd_fee)
            this.saleOrderItems[index].sol.x_monthly_fee =
              item.course.x_3rd_fee
            price = '3rd'
          }
        }
      }
      this.saleOrderItems[index].sol.price_unit =
        item.sol.x_enrollment_fee +
        item.sol.x_march_fee +
        8 * this.saleOrderItems[index].sol.x_monthly_fee +
        item.sol.x_december_fee
    },
    async updateOl (orderLine) {
      if (orderLine.id === undefined) {
        orderLine.order_id = this.saleOrder.id
        orderLine.id = await SaleOrderLinesService.create(orderLine)
      } else {
        const product = await ProductsService.list({
          product_tmpl_id: orderLine.product_template_id
        })
        const itemtoupdate = {
          x_enrollment_fee: parseInt(orderLine.x_enrollment_fee),
          x_march_fee: parseInt(orderLine.x_march_fee),
          x_monthly_fee: parseInt(orderLine.x_monthly_fee),
          x_december_fee: parseInt(orderLine.x_december_fee),
          price_unit:
            parseInt(orderLine.x_enrollment_fee) +
            parseInt(orderLine.x_march_fee) +
            8 * parseInt(orderLine.x_monthly_fee) +
            parseInt(orderLine.x_december_fee),
          product_id: product[0].id
        }
        if (orderLine.x_class_id !== undefined) {
          itemtoupdate.x_class_id = orderLine.x_class_id[0]
            ? orderLine.x_class_id[0]
            : orderLine.x_class_id
        }
        await SaleOrderLinesService.update(orderLine.id, itemtoupdate)
      }
      const ol = await SaleOrderLinesService.read(orderLine.id)
      return ol[0]
    },
    async saveDraft (index) {
      this.isLoadingSaleOrder = true
      for (let i = 0; i < this.saleOrderItems.length; i++) {
        if (this.saleOrderItems[i].sol.product_template_id !== undefined) {
          // console.log(this.saleOrderItems[i].sol)
          await this.updateOl(this.saleOrderItems[i].sol)
        }
      }
      this.isLoadingSaleOrder = false
    },
    async confirmEnrollment () {
      this.isLoadingSaleOrder = true
      const totals = {
        total: 0,
        enrollment: 0,
        march: 0,
        monthly: 0,
        december: 0
      }
      let students = ''
      const enrollmentIds = []
      for (var i = 0; i < this.saleOrderItems.length; i++) {
        if (this.saleOrderItems[i].sol.product_template_id !== undefined) {
          const updatedOl = await this.updateOl(this.saleOrderItems[i].sol)
          totals.enrollment += updatedOl.x_enrollment_fee
          totals.march += updatedOl.x_march_fee
          totals.monthly += updatedOl.x_monthly_fee
          totals.december += updatedOl.x_december_fee
          const enrollmentItem = {
            x_status: 'draft',
            x_name:
              updatedOl.x_student_id[1] + ' en ' + updatedOl.product_id[1],
            x_student_id: updatedOl.x_student_id[0],
            x_sale_order_line_id: updatedOl.id,
            x_class_id: updatedOl.x_class_id[0],
            x_year_id: this.$store.state.year.selected.id,
            x_sale_order_id: this.saleOrder.id
          }
          enrollmentIds.push(await EnrollmentsService.create(enrollmentItem))
          if (students.length === 0) {
            students +=
              ' ' +
              updatedOl.x_student_id[1] +
              ' en ' +
              updatedOl.product_id[1]
          } else {
            students +=
              ' y ' +
              updatedOl.x_student_id[1] +
              ' en ' +
              updatedOl.product_id[1]
          }
        }
      }
      await SaleOrdersService.execute('action_confirm', [[this.saleOrder.id]])
      this.saleOrder = await this.getSo(this.family.id)
      // console.log()
      await this.createDraftInvoices(totals, students)
      this.saleOrder = await this.getSo(this.family.id)
      await EnrollmentsService.update(enrollmentIds, {
        x_invoice_id: this.saleOrder.invoice_ids[0]
      })
      this.updateAccountMoves()
      this.updateSaleOrders()
      this.updateFamily()
      // await AccountMoveService.execute('action_post', [[this.saleOrder.invoice_ids[0]]])
      // await EnrollmentsService.update()
      this.saleOrder = {}
      this.saleOrderItems = []
      this.saleOrderLines = []
      this.formEnrollments = false
      this.isLoadingSaleOrder = false
    }
  }
}
</script>

<style lang="scss" scoped>
.labelFamilies {
  margin-bottom: 0.1rem;
}

#progress-row {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  /* Adjust z-index as needed */
}
</style>
